<template>
  <div class="m-2 text-dark text-center">
    <div class="text-left m-4">
      <h2 class="text-left">Notes</h2>
      <form v-if="!loanIsComplete">
        <hr />
        <div class="form-group row">
          <label for="notes" class="sr-only col-sm-3 col-form-label text-right">Notes</label>
          <div class="col-sm">
            <app-textarea id="notes" rows="3" v-model.trim="form.note.comment" />
          </div>
        </div>
        <div class="form-group row">
          <div class="col-12 text-right">
            <button type="submit" class="btn btn-sm btn-primary text-white" @click.prevent="addNote" :disabled="addNoteButtonDisabled">Add Note</button>
          </div>
        </div>
      </form>
      <hr />
      <div class="list-group" v-if="notesEmpty">
        <device-loan-note-item :note="note" v-for="note in notes" :key="note.id" />
      </div>
      <div class="text-center" v-else>
        There are no notes recorded for this device loan
      </div>
    </div>
    <ul class="list-inline">
      <li class="list-inline-item"><button class="btn btn-dark" @click.prevent="handleClose">Close</button></li>
    </ul>
  </div>
</template>

<script>
import DeviceLoanNoteItem from '@/components/DeviceLoanNotes/DeviceLoanNoteItem'

import { required, minLength } from 'vuelidate/lib/validators' 
import { xhrState } from '@/components/mixins/xhrState'

import api from '@/api'

export default {
  name: 'DeviceLoanNotesModal',
  mixins: [xhrState],
  components: {
    DeviceLoanNoteItem
  },
  props: {
    loan: {
      type: Object,
      required: true
    }
  },
  async created() {
    await this.fetchNotes()
  },
  validations: {
    form: {
      note: {
        comment: {
          required,
          minLength: minLength(5)
        }
      }
    }
  },
  data() {
    return {
      notes: null,
      form: {
        note: {
          comment: null
        }
      }
    }
  },
  computed: {
    loanIsComplete() {
      return !!this.loan.end_date
    },
    notesEmpty() {
      return this.notes === null || !!this.notes.length
    },
    addNoteButtonDisabled() {
      return !this.isXhrReady || this.$v.$invalid
    }
  },
  methods: {
    async fetchNotes() {
      this.setLoadingState()
      const notes = await api.devices.getDeviceLoanNotes(this.loan.device_id, this.loan.id)

      if(notes.status === 200) {
        this.notes = notes.data
        this.setReadyState()
      } else {
        this.setErrorState()
      }
    },
    async addNote() {
      this.setLoadingState()
      const addNote = await api.devices.addDeviceLoanNote(this.loan.device_id, this.loan.id, this.form.note)

      if(addNote.status === 201) {
        this.notes.unshift(addNote.data)
        this.clearForm()
        this.setReadyState()
      } else {
        this.setErrorState()
      }
    },
    clearForm() {
      this.form = {
        note: {
          comment: null
        }
      }
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>
